module.exports = __webpack_public_path__ + "assets/ic_check_off.fe63cf67.svg";